/**
 * Designed by OnHOW YouTube Channel - Anas El Medlaoui
 */

const onhowStyles = `
  .onhow-accordion {
    margin: 1rem 0;
    border: 1px solid #ffffffb0;
    border-radius: 0px;
    overflow: hidden;
  }
  
  .onhow-accordion details {
    border-bottom: 1px solid #e0e0e0;
  }
  
  .onhow-accordion details:last-child {
    border-bottom: none;
  }
  
  .onhow-accordion summary {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.25rem 1.5rem;
    cursor: pointer;
    background: #00000000;
    color: #ffffffc9;
    transition: background-color 0.2s ease;
    font-weight: 500;
    border: none;
    outline: none;
    min-height: 60px;
  }
  
  .onhow-accordion summary:hover {
    background-color:rgba(255, 255, 255, 0.1);
    color: #ffffff;
  }
  
  .onhow-accordion details[open] summary {
    background-color: #f9f9f90d;
    border-bottom: 1px solid #e0e0e0;
  }
  
  .onhow-accordion .accordion__title {
    font-size: 1.1em;
    font-weight: 600;
    margin: 0;
    color: #ffffff;
    line-height: 1.4;
  }
  
  .onhow-accordion .icon-caret {
    width: 16px;
    height: 16px;
    transform: rotate(0deg);
    transition: transform 0.2s ease;
    opacity: 0.7;
    flex-shrink: 0;
  }
  
  .onhow-accordion details[open] .icon-caret {
    transform: rotate(90deg);
  }
  
  .onhow-accordion .accordion__content {
    padding: 3rem 1.5rem;
    background-color: #f9f9f90d;
    border-top: 1px solid #e0e0e0;
    animation: slowReveal 300ms ease-out;
  }
  
  .onhow-accordion .accordion__content p, .onhow-accordion .accordion__content a {
    margin: 0 0 1rem 0;
    line-height: 1.6;
    color:rgb(249, 249, 249);
  }

  .onhow-accordion .accordion__content a:hover{
  color: #ffffff !important;
  }
  
  .onhow-accordion .accordion__content p:last-child {
    margin-bottom: -25px;
  }
  
  .onhow-accordion .accordion__content > *:first-child {
    margin-top: -25px;
  }
  
  .onhow-accordion .accordion__content ul,
  .onhow-accordion .accordion__content ol {
    margin: 0 0 1rem 0;
    padding-left: 1.5rem;
  }
  
  .onhow-accordion .accordion__content li {
    margin-bottom: 0.5rem;
    line-height: 4.5rem;
    color: #555;
  }
  
  .post-accordion-content {
    margin-top: 2rem;
    padding-top: 1rem;
    border-top: 1px solid #e0e0e0;
  }
  
  .post-accordion-content p {
    margin: 0 0 1rem 0;
    line-height: 1.6;
  }
  
  .post-accordion-content img {
    max-width: 100%;
    height: auto;
    margin: 0.5rem 0;
  }
  
  @keyframes slowReveal {
    0% { opacity: 0; transform: translateY(-10px); }
    100% { opacity: 1; transform: translateY(0); }
  }
`;

function addStyles(stylesText) {
  const styleElement = document.createElement('style');
  styleElement.textContent = stylesText;
  document.head.appendChild(styleElement);
}

class OnhowDescriptionAccordion {
  constructor() {
    this.descriptionContainer = this.findContainer();
    if (!this.descriptionContainer) return;
    
    addStyles(onhowStyles);
    this.init();
  }

  findContainer() {
    const containers = [
      '.product__description.rte',
      'rte-formatter.rte',
      'rte-formatter'
    ];
    
    for (const selector of containers) {
      const elements = document.querySelectorAll(selector);
      for (const element of elements) {
        if (element.querySelectorAll('h6').length > 0) {
          return element;
        }
      }
    }
    return null;
  }

  init() {
    const originalContent = this.descriptionContainer.cloneNode(true);
    const accordionSections = this.findAccordionSections(originalContent);
    
    if (accordionSections.length > 0) {
      this.createAccordion(accordionSections);
      this.hideOriginalSections();
    }
  }
  
  findAccordionSections(container) {
    const sections = [];
    const h6Elements = container.querySelectorAll('h6');
    
    h6Elements.forEach((h6, index) => {
      const title = h6.textContent.trim();
      const originalH6 = this.descriptionContainer.querySelector(`h6:nth-of-type(${index + 1})`);
      const content = this.getContentUntilDelimiter(originalH6);
      
      if (content.html.trim()) {
        sections.push({
          title: title,
          content: content.html,
          originalElements: [originalH6, ...content.elements]
        });
      }
    });
    
    return sections;
  }
  
  getContentUntilDelimiter(h6Element) {
    const contentElements = [];
    const contentHtml = [];
    let currentElement = h6Element.nextElementSibling;
    
    while (currentElement) {
      const elementHtml = currentElement.outerHTML;
      const elementText = currentElement.textContent;
      
      if (elementText.includes('$')) {
        const parts = elementHtml.split('$');
        contentHtml.push(parts[0]);
        contentElements.push(currentElement);
        break;
      } else {
        contentHtml.push(elementHtml);
        contentElements.push(currentElement);
        currentElement = currentElement.nextElementSibling;
      }
    }
    
    return {
      html: contentHtml.join(''),
      elements: contentElements
    };
  }
  
  createAccordion(accordionSections) {
    const accordionContainer = document.createElement('div');
    accordionContainer.className = 'onhow-accordion';
    
    accordionSections.forEach((section, index) => {
      const isOpen = index === 0;
      
      const details = document.createElement('details');
      if (isOpen) details.setAttribute('open', '');
      details.id = `onhow-accordion-${index}`;
      
      const summary = document.createElement('summary');
      summary.setAttribute('role', 'button');
      summary.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      summary.setAttribute('aria-controls', `onhow-content-${index}`);
      
      const title = document.createElement('h2');
      title.className = 'accordion__title';
      title.innerHTML = section.title;
      
      const icon = document.createElement('span');
      icon.innerHTML = `<svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" class="icon icon-caret" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></path>
      </svg>`;
      
      summary.appendChild(title);
      summary.appendChild(icon);
      
      const content = document.createElement('div');
      content.className = 'accordion__content';
      content.id = `onhow-content-${index}`;
      content.innerHTML = section.content.replace(/\$/g, '');
      
      details.appendChild(summary);
      details.appendChild(content);
      accordionContainer.appendChild(details);
    });
    
    this.descriptionContainer.insertBefore(accordionContainer, this.descriptionContainer.firstChild);
    this.initializeAccordion(accordionContainer);
  }
  
  hideOriginalSections() {
    const h6Elements = this.descriptionContainer.querySelectorAll('h6');
    
    h6Elements.forEach(h6 => {
      h6.style.display = 'none';
      
      let currentElement = h6.nextElementSibling;
      
      while (currentElement) {
        if (currentElement.tagName === 'H6' || currentElement.textContent.includes('$')) {
          if (currentElement.textContent.includes('$')) {
            currentElement.style.display = 'none';
          }
          break;
        }
        
        currentElement.style.display = 'none';
        currentElement = currentElement.nextElementSibling;
      }
    });
  }
  
  initializeAccordion(accordionContainer) {
    const summaries = accordionContainer.querySelectorAll('summary');
    
    summaries.forEach(summary => {
      summary.addEventListener('click', (event) => {
        const details = event.currentTarget.parentElement;
        const isOpen = details.hasAttribute('open');
        event.currentTarget.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
      });
      
      summary.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') {
          const details = event.currentTarget.parentElement;
          if (details.hasAttribute('open')) {
            details.removeAttribute('open');
            event.currentTarget.setAttribute('aria-expanded', 'false');
            event.currentTarget.focus();
          }
        }
      });
    });
  }
}

(function() {
  function initAccordion() {
    const containers = document.querySelectorAll('.product__description.rte, rte-formatter.rte, rte-formatter');
    
    if (containers.length > 0) {
      new OnhowDescriptionAccordion();
    } else if (document.readyState !== 'complete') {
      setTimeout(initAccordion, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccordion);
  } else {
    initAccordion();
  }
})();